import { Auth } from 'aws-amplify';

const devMode = process.env.NODE_ENV === 'development';

const apiConfig = devMode
  ? {
      amplifyConfig: {
        loginString: 'cognito-idp.eu-west-1.amazonaws.com/eu-west-1_aopqlhZ37',
        Auth: {
          identityPoolId: 'eu-west-1:0ba79904-5073-456b-b903-4d4eb898a5d1',
          userPoolId: 'eu-west-1_aopqlhZ37',
          userPoolWebClientId: '7cb6jt6gos920q5jb2qofe1m8c',
          region: 'eu-west-1', // REQUIRED - Amazon Cognito Region
          mandatorySignIn: false,
        },
        Storage: {
          bucket: 'lb-media-service-dev', // REQUIRED -  Amazon S3 bucket
          region: 'eu-west-1', // OPTIONAL -  Amazon service region
        },
        API: {
          graphql_endpoint:
            'https://02yf2d60xk.execute-api.eu-west-1.amazonaws.com/dev/graphql',
          graphql_headers: async () => {
            const currentSession = await Auth.currentSession();
            const token = currentSession.idToken.jwtToken;
            return { Authorization: token };
          },
        },
      },
    }
  : {
      amplifyConfig: {
        loginString: 'cognito-idp.eu-west-1.amazonaws.com/eu-west-1_IEZjsnoRW',
        Auth: {
          identityPoolId: 'eu-west-1:f02ea990-812d-4e33-a22d-701d766fda9e',
          userPoolId: 'eu-west-1_IEZjsnoRW',
          userPoolWebClientId: '7lrllq2d3qtlf2jl3gf2k31m57',
          region: 'eu-west-1', // REQUIRED - Amazon Cognito Region
          mandatorySignIn: false,
        },
        Storage: {
          bucket: 'lb-media-service-prod', // REQUIRED -  Amazon S3 bucket
          region: 'eu-west-1', // OPTIONAL -  Amazon service region
        },
        API: {
          graphql_endpoint:
            'https://gsjiqeh2j5.execute-api.eu-west-1.amazonaws.com/prod/graphql',
          graphql_headers: async () => {
            const currentSession = await Auth.currentSession();
            const token = currentSession.idToken.jwtToken;
            return { Authorization: token };
          },
        },
      },
    };

export default apiConfig;



// WEBPACK FOOTER //
// ./src/config/api.js